import * as STD                         from '@emersya/mpa-std-lib';
import CM                               from '@emersya/mpa-components-manager-lib';

export interface IFieldComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class FieldComponent extends CM.DOMComponent<
	HTMLDivElement,
	FieldComponent,
	IFieldComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await <any> void 1;
		const c = ev.target;
		const valueRaw = ev.details.newValue;
		let value : string;
		if (c instanceof InputButtonComponent) {
			value = c.component_getTranslated('text');
		} else if (c instanceof InputSelectComponent) {
			value = (valueRaw === null) ? '' : valueRaw.component_getTranslated('text');
		} else if (c instanceof InputSelectMultipleComponent) {
			value = '';
		} else if (c instanceof InputImageComponent) {
			value = '';
		} else if (c instanceof InputTextComponent) {
			value = valueRaw;
		} else if (
			(c instanceof InputNumberComponent) ||
			(c instanceof InputBoolComponent)
		)
		{
			value = valueRaw.toString();
		} else {
			value = 'NULL';
		}
		const valueTextComponent = <TextComponent> this.component_find('@:header.value');
		valueTextComponent.update(value);
	};

	async updateValue(value : unknown) {
		const input = this.component_outerChilds[ 0 ];
		if (!(input instanceof InputComponent)) {
			this.component_throwLibraryError('', { input });
		}
		await input.updateValue(value);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IFieldComponentConfiguration
	)
	{
		if (configuration[ '@translations' ] && configuration[ '@translations' ].label) {
			if (!configuration[ '@innerConfigurations' ]) {
				configuration[ '@innerConfigurations' ] = {};
			}
			if (!configuration[ '@innerConfigurations' ].header) {
				configuration[ '@innerConfigurations' ].header = {};
			}
			if (!configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ]) {
				configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ] = {};
			}
			if (!configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ].label) {
				configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ].label = {};
			}
			if (!configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ].label[ '@translations' ]) {
				configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ].label[ '@translations' ] = {};
			}
			configuration[ '@innerConfigurations' ].header[ '@innerConfigurations' ].label[ '@translations' ].text =
				configuration[ '@translations' ].label;
		}
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export const Component = FieldComponent;
	export type Component = FieldComponent;
	export type Configuration = IFieldComponentConfiguration;
}
;
import manifestXMLSource                from './Field.xml';
import './Field.scss';
import { TextComponent }                from '../Text/Text';
import { InputButtonComponent }         from '../inputs/InputButton/InputButton';
import { InputSelectComponent }         from '../inputs/InputSelect/InputSelect';
import { InputSelectMultipleComponent } from '../inputs/InputSelectMultiple/InputSelectMultiple';
import { InputNumberComponent }         from '../inputs/InputNumber/InputNumber';
import { InputImageComponent }          from '../inputs/InputImage/InputImage';
import { InputBoolComponent }           from '../inputs/InputBool/InputBool';
import { InputTextComponent }           from '../inputs/InputText/InputText';
import { InputComponent }               from '../inputs/Input/Input';

CM.declare({
	id :       'field',
	type :     FieldComponent,
	manifest : manifestXMLSource
});
